/**
 * The maximum uint64 value – an impossibly large, intentionally invalid value
 * for `satoshis`. See `Transaction.satoshis` for details.
 */
// prettier-ignore
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const invalidSatoshis = Uint8Array.from([255, 255, 255, 255, 255, 255, 255, 255]);
//# sourceMappingURL=transaction-types.js.map